import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

export const styleProps = {
  size: "text-lg",
  leading: "leading-7",
  tracking: "tracking-tightest",
};

export interface BodyLgProps extends TextInternalProps {
  "data-testid"?: string;
}

export const BodyLg = ({
  weight = "normal",
  color,
  truncate,
  [DATA_TESTID]: dataTestId,
  children,
  ...otherProps
}: BodyLgProps) => {
  const props = {
    ...styleProps,
    color,
    weight: `font-${weight}`,
    dataTestId,
    truncate,
    ...otherProps,
  };

  return (
    <Text_INTERNAL as="p" {...props}>
      {children}
    </Text_INTERNAL>
  );
};
